import { RootState } from '@/App/store';

export const selectTimeoutConfig = (state: RootState) => state.info.timeoutConfig;
